import { useStore } from 'effector-react'
import {
  $revisionsHistory,
  $totalCountOfRevisionsHistory,
  createRevision,
  revisionMounted,
  walletMounted,
} from './model'
import { useEffect } from 'react'
import { $wallet } from '../../wallets/details/model'

export const useRevision = () => {
  const revisionsHistory = useStore($revisionsHistory)
  const totalCountOfRevisionsHistory = useStore($totalCountOfRevisionsHistory)
  const wallet = useStore($wallet)
  const isCreateRevisionLoading = useStore(createRevision.pending)

  useEffect(() => {
    revisionMounted()
    walletMounted()
  }, [])

  return {
    revisionsHistory,
    totalCountOfRevisionsHistory,
    wallet,
    isCreateRevisionLoading,
  }
}
